module.exports = __webpack_public_path__ + "static/4fc2c5bb049b6a21932a703f4aba563e89144e115a14a502110e201cec3263c6-fc9175244a17794be850a8ae79bc5867.png";